import {
  BUNDLE_TYPE_COMBO, BUNDLE_TYPE_PACKAGE, EXPERIENCE_TYPE_GM, EXPERIENCE_TYPE_KITCHEN, EXPERIENCE_TYPE_LAUNDRY
} from './base-configuration';
import { COMBO_EXPERIENCE_FEATURES,
  LAUNDRY_EXPERIENCE_FEATURES,
  KITCHEN_EXPERIENCE_FEATURES } from './bundle-features-constants';

const KITCHEN_ENTRY_POINT = {
  ...KITCHEN_EXPERIENCE_FEATURES,
  impressionName: 'KitchenPackage',
  templates: {
    singleParent: 'BundleMiniItem',
    multiParent: 'MultiParentCarousel'
  },
  multiParentFulfillment: false
};

const GM_ENTRY_POINT = {
  ...COMBO_EXPERIENCE_FEATURES,
  impressionName: 'GMCombo',
  templates: {
    singleParent: 'BundleMiniItem',
    multiParent: 'MultiParentCarousel'
  },
  multiParentFulfillment: true
};

const LAUNDRY_COMBO_ENTRY_POINT = {
  ...LAUNDRY_EXPERIENCE_FEATURES,
  templates: {
    singleParent: 'BundleMiniItem',
    multiParent: 'MultiParentCarousel'
  }
};

const LAUNDRY_ENTRY_POINT = {
  ...LAUNDRY_EXPERIENCE_FEATURES,
  impressionName: 'LaundryPackage',
  templates: {
    singleParent: 'BundleLaundryMiniItem'
  },
  multiParentFulfillment: false
};

export const ENTRY_POINT_CONFIGURATION = {
  [BUNDLE_TYPE_COMBO]: {
    [EXPERIENCE_TYPE_GM]: GM_ENTRY_POINT,
    [EXPERIENCE_TYPE_LAUNDRY]: LAUNDRY_COMBO_ENTRY_POINT
  },
  [BUNDLE_TYPE_PACKAGE]: {
    [EXPERIENCE_TYPE_KITCHEN]: KITCHEN_ENTRY_POINT,
    [EXPERIENCE_TYPE_LAUNDRY]: LAUNDRY_ENTRY_POINT,
    [EXPERIENCE_TYPE_GM]: GM_ENTRY_POINT
  }
};